import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import LicenseGate from '../components/ui/LicenseGate';
import DashboardSectionAnchor from '../components/ui/DashboardSectionAnchor';
import { 
  KPIsSection, 
  SurveyResponsesByAnswer, 
  ComplaintReviewStatus, 
  DissatisfactionReasons, 
  DissatisfiedProducts 
} from '../components/refineCustomer';
// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

interface RefineCustomerDashboardProps {
  branchId?: number;
}

const RefineCustomerDashboard: React.FC<RefineCustomerDashboardProps> = ({ branchId = 0 }) => {
  return (
    <LicenseGate licenseType="evaluation" dashboardName="داشبورد نظرسنجی و رضایتمندی مشتریان">
      <div className="container-dashboard" dir="rtl">
        <div className="space-y-8 md:space-y-10 animate-enter-up">
          {/* Dashboard Title */}
          <h1 className="title-dashboard">نظرسنجی و رضایتمندی مشتریان — یک ماه اخیر</h1>

          {/* KPI Cards Section - Now self-contained */}
          <DashboardSectionAnchor sectionId="refine-kpis">
            <KPIsSection branchId={branchId} />
          </DashboardSectionAnchor>

          {/* Survey Responses Section */}
          <h2 className="title-section">تحلیل دلایل نظرسنجی</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DashboardSectionAnchor sectionId="survey-responses-by-answer">
              <SurveyResponsesByAnswer branchId={branchId} />
            </DashboardSectionAnchor>
            <DashboardSectionAnchor sectionId="complaint-review-status">
              <ComplaintReviewStatus branchId={branchId} />
            </DashboardSectionAnchor>
          </div>

          {/* Dissatisfaction Reasons */}
          <h2 className="title-section">تحلیل دلایل نارضایتی</h2>
          <DashboardSectionAnchor sectionId="dissatisfaction-reasons">
            <DissatisfactionReasons branchId={branchId} />
          </DashboardSectionAnchor>

          {/* Dissatisfied Products Table */}
          <h2 className="title-section">گزارش محصولات ناراضی</h2>
          <DashboardSectionAnchor sectionId="dissatisfied-products">
            <DissatisfiedProducts branchId={branchId} />
          </DashboardSectionAnchor>
        </div>
      </div>
    </LicenseGate>
  );
};

export default RefineCustomerDashboard;